export default {
    COREN: 1,
    CREF: 2,
    CREFITO: 3,
    CRESS: 4,
    CRF: 5,
    CRFA: 6,
    CRM: 7,
    CRMV: 8,
    CRN: 9,
    CRO: 10,
    CRP: 11,
    RMS: 12,
    CRBM: 13,
    OUTRO: 14,
    CREFONO: 15,
    CRBIO: 16
}